export default __webpack_public_path__ + "static/whatsappLogo-e924b82f6ba475a5fa53b4568c72702f.svg";